
import { reactive, toRefs, Ref, PropType, watchEffect, computed, ComputedRef } from 'vue'
import { Popup, Button } from 'vant'
import { getRequestLanguage } from '@/api/utils'

interface MDialogState {
  isShowDialog: Ref<boolean>
  vanPopupStyle: Ref<object>
  handleClickBtn: () => void
  handleClose: () => void
  language: Ref<string>
  qrCodeWidth: ComputedRef<number>
}
export default {
  name: 'MDialog',
  components: {
    [Popup.name as string]: Popup,
    [Button.name as string]: Button
  },
  props: {
    show: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    },
    style: {
      type: Object as PropType<object>,
      default: null
    },
    headerText: {
      type: String as PropType<string>,
      default: '手机扫码下载weelife App'
    },
    btnText: {
      type: String as PropType<string>,
      default: '下载App'
    },
    qrCodeUrl: {
      type: String as PropType<string>,
      default: window.location.href
    },
    qrCodeLogo: {
      type: String as PropType<string>,
      default: 'logo.png'
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: true
    },
    onDownload: {
      type: Function as PropType<() => void>,
      required: true
    }
  },
  setup(
    props: Readonly<{
      show: boolean
      style: object
      onClose: () => void
      onDownload: () => void
    }>
  ): MDialogState {
    const state = reactive<{
      isShowDialog: boolean
      vanPopupStyle: object
    }>({
      isShowDialog: props.show,
      vanPopupStyle: props.style
    })

    const qrCodeWidth = computed(() => {
      if (window.innerHeight < 500) {
        return 110
      } else {
        return 200
      }
    })

    watchEffect(() => {
      state.isShowDialog = props.show
    })

    watchEffect(() => {
      state.vanPopupStyle = props.style
    })

    const handleClickBtn = () => {
      props.onDownload()
    }

    const handleClose = () => {
      props.onClose()
    }

    const language = computed(() => {
      return getRequestLanguage()
    })

    return {
      ...toRefs(state),
      handleClickBtn,
      handleClose,
      language,
      qrCodeWidth
    }
  }
}
